import { css } from 'styled-components';

export const textStyles = {
  'text-preset-1': () => css`
    font-size: 44px;
    line-height: 50px;
    font-family: Rubik,serif;
  `,
  'text-preset-2': () => css`
    font-size: 34px;
    line-height: 40px;
    font-family: Rubik,serif;
  `,
  'text-preset-3': () => css`
    font-size: 28px;
    line-height: 34px;
    font-family: Rubik,serif;
  `,
  'text-preset-4': () => css`
    font-size: 22px;
    line-height: 28px;
    font-family: Rubik,serif;
  `,
  'text-preset-5': () => css`
    font-size: 20px;
    line-height: 28px;
    font-family: Rubik,serif;
  `,
  'text-preset-6': () => css`
    font-size: 16px;
    line-height: 24px;
    font-family: Rubik,serif;
  `,
  'text-preset-7': () => css`
    font-size: 14px;
    line-height: 24px;
    font-family: Rubik,serif;
  `,
  'text-preset-8': () => css`
    font-size: 16px;
    line-height: 24px;
    font-family: Roboto,serif;
  `,
  'text-preset-9': () => css`
    font-size: 14px;
    line-height: 24px;
    font-family: Roboto,serif;
  `,
  'text-preset-10': () => css`
    font-size: 12px;
    line-height: 16px;
    font-family: Roboto,serif;
  `,
  'text-preset-11': () => css`
    font-size: 10px;
    line-height: 14px;
    font-family: Roboto,serif;
  `,
};

